import { localManagedVenueSource } from '@/lib/venue/managedVenue'

import { readReturnTo } from './returnTo'

/**
 * 구장 진입 시 기본으로 여는 하위 경로 (설계 D11).
 *
 * 대시보드 화면이 붙었으므로(#592) 로그인 직후 진입지를 `'dashboard'` 로 옮긴다.
 * 인덱스(구장 홈, `''`)는 대체되지 않고 그대로 남아 있다 — 직접 링크로 접근할 수 있다.
 */
export const DEFAULT_VENUE_ROUTE: string = 'dashboard'

export function venueHomePath(venueId: string): string {
  return DEFAULT_VENUE_ROUTE === ''
    ? `/venues/${venueId}`
    : `/venues/${venueId}/${DEFAULT_VENUE_ROUTE}`
}

/**
 * 로그인 직후·루트 진입 시 목적지를 정하는 **단 하나의 함수** (설계 §2-2(5)).
 *
 * 우선순위: `returnTo`(오픈 리다이렉트 차단 통과분) → 마지막 구장 → 구장 선택.
 * 로그인 화면·`/`·`GuestRoute` 세 곳이 각자 목적지를 계산하면 서로 어긋난다.
 *
 * 🚨 **동기 함수로 유지한다.** 라우트 가드가 렌더 중에 부르므로 서버 조회를 끼워 넣을 수 없다.
 * 마지막 구장이 이제 내 것이 아니면 `VenueLayout` 이 접근 불가 안내로 잡아 준다(설계 §2-1(d)).
 */
export function resolvePostLoginPath(search?: string): string {
  const returnTo = readReturnTo(search ?? '')
  if (returnTo) return returnTo

  const venueId = localManagedVenueSource.resolveInitial()
  return venueId === null ? '/venues/select' : venueHomePath(venueId)
}
